<template>
  <div class="block md:grid gap-x-lg grid-cols-pageWide mb-4">
    <h3 id="invoices-title" class="mb-none col-span-full">{{ $t('companySettings.billing.invoicesSection.title') }}</h3>
    <hr class="my-sm col-span-full" />
    <span id="invoices-info" class="col-span-1 mt-sm">{{ $t('companySettings.billing.invoicesSection.info') }}</span>
    <div class="col-span-1">
      <div v-if="invoices.length" id="invoices-invoice-list">
        <BillingInvoice
            v-for="(invoice, index) in invoices"
            :id="`invoices-invoiceCard-${invoice.id}`"
            class="last:mb-none"
            :key="index"
            :invoice="invoice"
        />
      </div>
      <div v-else class="col-span-1 mt-xs">
        <VMessage
          id="invoices-no-invoices-warning"
          type="info"
          subtype="outlined"
          :fullwidth="true">
          <template v-slot:icon>
            <ExclamationTriangleIcon />
          </template>
          <template v-slot:text>
            {{ $t('companySettings.billing.invoicesSection.noInvoices') }}
          </template>
        </VMessage>
      </div>

    </div>
    <div>
    </div>
  </div>
</template>

<script>
import VMessage from '@/components/deprecated/atoms/Message.vue';
import BillingInvoice from '@/views/components/billing/InvoiceCard.vue';
import { ExclamationTriangleIcon } from '@/components/icons/fontIcons';

export default {
  name: 'BillingInvoices',
  components: {
    BillingInvoice,
    VMessage,
    ExclamationTriangleIcon,
  },
  props: {
    invoices: Array,
  },
};
</script>
